module.exports = __webpack_public_path__ + "components/flag/static/square/sd-4ee30d8dc0c701c40cd36e135a196d08.svg";